"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardTeamsReportExpandOption = exports.DashboardTeamReportMetricChangeReaction = exports.DashboardTeamReportMetric = void 0;
var DashboardTeamReportMetric;
(function (DashboardTeamReportMetric) {
    DashboardTeamReportMetric["LeadTimeHours"] = "LeadTimeHours";
    DashboardTeamReportMetric["MergedPRsCount"] = "MergedPRsCount";
    DashboardTeamReportMetric["MergedPRFrequencyDay"] = "MergedPRFrequencyDay";
    DashboardTeamReportMetric["PRCycleWorkInProgressHours"] = "PRCycleWorkInProgressHours";
    DashboardTeamReportMetric["PRCycleInReviewHours"] = "PRCycleInReviewHours";
    DashboardTeamReportMetric["PRCycleAwaitingReviewHours"] = "PRCycleAwaitingReviewHours";
    DashboardTeamReportMetric["PRCycleReviewedHours"] = "PRCycleReviewedHours";
    DashboardTeamReportMetric["PRCycleTotalTimeHours"] = "PRCycleTotalTimeHours";
    DashboardTeamReportMetric["BugsCount"] = "BugsCount";
    DashboardTeamReportMetric["MTTR"] = "MTTR";
    DashboardTeamReportMetric["BugsFixedToBugsOpenedRate"] = "BugsFixedToBugsOpenedRate";
    DashboardTeamReportMetric["AveragePRSizeLOC"] = "AveragePRSizeLOC";
    DashboardTeamReportMetric["CompletedTicketsCount"] = "CompletedTicketsCount";
    DashboardTeamReportMetric["PRLinkedToTasksOutOfPRs"] = "PRLinkedToTasksOutOfPRs";
    DashboardTeamReportMetric["ActiveDaysCount"] = "ActiveDaysCount";
    DashboardTeamReportMetric["MergedPRSizeLOCSum"] = "MergedPRSizeLOCSum";
    DashboardTeamReportMetric["OpenPRsCount"] = "OpenPRsCount";
    DashboardTeamReportMetric["PRsReviewedCount"] = "PRsReviewedCount";
    DashboardTeamReportMetric["VelocityStoryPointsCompleted"] = "VelocityStoryPointsCompleted";
    DashboardTeamReportMetric["VelocityEstimatedTimeCompleted"] = "VelocityEstimatedTimeCompleted";
    DashboardTeamReportMetric["NumberOfClosedUnmergedPRs"] = "NumberOfClosedUnmergedPRs";
    DashboardTeamReportMetric["NumberOfTasksCompletedPriorityHighest"] = "NumberOfTasksCompletedPriorityHighest";
    DashboardTeamReportMetric["NumberOfTasksCompletedPriorityHigh"] = "NumberOfTasksCompletedPriorityHigh";
    DashboardTeamReportMetric["NumberOfTasksCompletedPriorityNormal"] = "NumberOfTasksCompletedPriorityNormal";
    DashboardTeamReportMetric["NumberOfTasksCompletedPriorityLowAndLowest"] = "NumberOfTasksCompletedPriorityLowAndLowest";
})(DashboardTeamReportMetric = exports.DashboardTeamReportMetric || (exports.DashboardTeamReportMetric = {}));
var DashboardTeamReportMetricChangeReaction;
(function (DashboardTeamReportMetricChangeReaction) {
    DashboardTeamReportMetricChangeReaction["Positive"] = "Positive";
    DashboardTeamReportMetricChangeReaction["Neutral"] = "Neutral";
    DashboardTeamReportMetricChangeReaction["Negative"] = "Negative";
})(DashboardTeamReportMetricChangeReaction = exports.DashboardTeamReportMetricChangeReaction || (exports.DashboardTeamReportMetricChangeReaction = {}));
var DashboardTeamsReportExpandOption;
(function (DashboardTeamsReportExpandOption) {
    DashboardTeamsReportExpandOption["DevStats"] = "DevStats";
})(DashboardTeamsReportExpandOption = exports.DashboardTeamsReportExpandOption || (exports.DashboardTeamsReportExpandOption = {}));
//# sourceMappingURL=dashboard-teams-report.js.map